import { HStack, Text, VStack } from "@chakra-ui/react";
import { StepProps } from "./CreateCampaignWizard";
import Navigation from "./Navigation";
import AdsetList from "./AdsetList";

const AdsetListStep = (props: StepProps) => {
  const { next, back, steps } = props;
  const isCreateCampaign = steps.at(0) === "create_campaign";
  return (
    <VStack w="full" gap={4}>
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Text
          fontSize={"lg"}
          textTransform={"uppercase"}
          fontWeight={"bold"}
          color={"gray.400"}
        >
          Adsets
        </Text>
      </HStack>
      <AdsetList {...props} />
      <Navigation
        back={isCreateCampaign ? null : back}
        next={next}
        canNext
      />
    </VStack>
  );
};

export default AdsetListStep;
